import { Component, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReplenishmentApiService } from 'src/app/replenishment/services/replenishment-api.service';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Replenishment } from '../../../models/replenishment.model';
import { TableHeaders } from '../../../../utils/table/models/tableHeaders.model';
import { TableAlign } from '../../../../utils/table/models/tableAlign.enum';
import { TableCell } from '../../../../utils/table/models/tableCell.model';
import { TableCellType } from '../../../../utils/table/models/tableCellType.enum';

@Component({
  selector: 'app-replenishment-related-edit-modal',
  templateUrl: './replenishment-related-edit-modal.component.html',
})
export class ReplenishmentRelatedEditModalComponent implements OnDestroy {
  replenishmentId: number;

  relatedLocations = [];

  relatedLocationsToShow: Replenishment[] = [];

  private destroy$: Subject<void> = new Subject();

  headers: TableHeaders[] = [{ value: 'Product' }, { value: 'Picking location', align: TableAlign.center }];

  cells: TableCell[] = [
    { type: TableCellType.text, key: 'product.name' },
    { type: TableCellType.text, key: 'sourceLocation.barcode', align: TableAlign.center },
  ];

  constructor(
    public modal: BsModalRef,
    public toastrService: ToastrService,
    public modalService: BsModalService,
    private replenishmentApiService: ReplenishmentApiService,
    public router: Router,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reserveOne(): void {
    this.replenishmentApiService
      .postReserveReplenishment([this.replenishmentId])
      .pipe(
        tap(() => {
          this.showSuccessAlertAndClose();
          const currentUrl = this.router.url;
          this.reloadComponent();
        }),
        takeUntil(this.destroy$),
        catchError(err => of(err)),
      )
      .subscribe();
  }

  reserveRelated(): void {
    const replenishments = this.relatedLocations.map(location => location.id);
    this.replenishmentApiService
      .postReserveReplenishment(replenishments)
      .pipe(
        tap(() => {
          this.showSuccessAlertAndClose();
          this.reloadComponent();
        }),
        takeUntil(this.destroy$),
        catchError(err => of(err)),
      )
      .subscribe();
  }

  private showSuccessAlertAndClose(): void {
    this.toastrService.success('Product has been reserved');
    this.modalService.setDismissReason('product_reserved');
    this.modal.hide();
  }

  // @TODO: move to service / refresh after click 'reserved'
  reloadComponent() {
    const currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
}
